function setFormikFieldValues(
  setFieldValue,
  address_components,
  googleGeocodeResult
) {
  // setFieldValue is a function from Formik to (imperatively)
  //     edit Formik fields.
  // address_components
  //     TODO insert description of what exactly this is

  // TODO Document what exactly this is doing
  const address_found = {};

  // Return value is the text to appear in Google activated field after
  // search is complete.
  let google_field_text = '';

  address_components.forEach(component => {
    const address_field = component.toLowerCase(); // is this necessary?

    // Address field names are expected to include the strings
    // used with String.prototype.includes
    if (!googleGeocodeResult) {
      // googleGeocodeResult is Google's first address search result;
      // If this is not found there is nothing to do
      return;

      // Find rest of the fields by checking "type" on array elements of...
    } else if (address_field.includes('address1')) {
      // Imperatively go through googleGeocodeResult until desired thing is found
      let address_first_line_arr = []; // Just doing this by string addition for now
      for (let i = 0; i < googleGeocodeResult.length; i++) {
        if (googleGeocodeResult[i].types.includes('street_number')) {
          // Add street number, if any
          address_first_line_arr.push(googleGeocodeResult[i].long_name);
        } else if (googleGeocodeResult[i].types.includes('route')) {
          // Add rest of street name
          address_first_line_arr.push(googleGeocodeResult[i].long_name);
          // Exit once this done
          break;
        }
      }
      // Combine fields with Array.prototype.join
      const address_first_line_string = address_first_line_arr.join(' ');
      address_found[component] = address_first_line_string;

      // Copy block scoped variable to function block scoped value to return
      // eventually.
      google_field_text = address_first_line_string;
    } else if (address_field.includes('address2')) {
      // It seems Google geocoding doesn't include address2 fields;
      // ignore here and let user fill in manually

    } else if (address_field.includes('city')) {
      for (let i = 0; i < googleGeocodeResult.length; i++) {
        if (
          googleGeocodeResult[i].types.includes('locality') &&
          googleGeocodeResult[i].types.includes('political')
        ) {
          address_found[component] = googleGeocodeResult[i].long_name;
          break;
        }
      }
    } else if (address_field.includes('zip')) {
      for (let i = 0; i < googleGeocodeResult.length; i++) {
        if (googleGeocodeResult[i].types.includes('postal_code')) {
          // Note some addresses may have "postal_code_suffix"; this is omitted.
          address_found[component] = googleGeocodeResult[i].long_name;
          break;
        }
      }
    } else if (address_field.includes('state')) {
      for (let i = 0; i < googleGeocodeResult.length; i++) {
        if (
          googleGeocodeResult[i].types.includes(
            'administrative_area_level_1'
          ) &&
          googleGeocodeResult[i].types.includes('political')
        ) {
          // Note some addresses may have "postal_code_suffix"; this is omitted.
          address_found[component] = googleGeocodeResult[i].short_name; // e.g. CA
          break;
        }
      }
    }
    // Set Formik values
    setFieldValue(component, address_found[component]);
  });

  return google_field_text;
}

export { setFormikFieldValues };
